import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import type { TranslationKey } from '@/types/translations';

const StatsSection: React.FC = () => {
  const { t } = useLanguage();
  
  const stats: Array<{ value: string | TranslationKey; label: TranslationKey; isTranslationKey: boolean }> = [
    { value: '100+', label: 'stats.products', isTranslationKey: false },
    { value: '50+', label: 'stats.projects', isTranslationKey: false },
    { value: '500+', label: 'stats.satisfiedCustomers', isTranslationKey: false },
    { value: 'stats.position', label: 'stats.topLocalBrand', isTranslationKey: true },
  ] as const;

  return (
    <section className="py-10 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-4 gap-4 w-full">
          {stats.map((stat) => (
            <div key={stat.label} className="flex flex-col items-center">
              <span className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
                {stat.isTranslationKey ? t(stat.value as TranslationKey) : stat.value}
              </span>
              <span className="text-base md:text-lg text-gray-600">{t(stat.label)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection; 